<template>
  <div id="app">
    <v-app>
      <v-row class="m-0">
        <div class="m-bg">
          <video autoplay loop muted id="video-background" ref="videoss">
            <source :src="'/assets/img/moharam/test1.mp4'" type="video/mp4">
          </video>

          <div class="au-container" >
            <button ref="soundButton" @click="toggleSound">
              <img :src="isMuted ? '/assets/img/moharam/volume-2.svg' : '/assets/img/moharam/volume-x.svg'" alt="">
            </button>
             <div class="serv" style="padding: 8px;">
      <svg viewBox="0 0 25 30" style="height: 26px;" @click="dialog = true">
        <use xlink:href="/assets/img/services/lang.svg#view"></use>
      </svg>
    </div>

    <v-dialog v-model="dialog" max-width="400" overlay-opacity="0.7">
      <v-card class="black-overlay">
        <v-card-text class="white--text text-center pb-0">
          <v-list>
            <v-list-item v-for="(language, index) in languages" :key="index">
              <v-list-item-content> 
                <a class="lang-text" style="text-decoration: none; margin:0 10px" :href="'?lang='+language.code">
                  <v-list-item-title>{{ language.name }}</v-list-item-title>
                </a>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="lang-bu" text @click="dialog = false">إغلاق</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
            
          </div>
        </div>

        <router-link :to="'/?lang='+lang" class="mx-auto pt-6">
          <v-img contain height="72" width="300" position="center center"
            :src="'https://alkafeel.net/'+lang_src+'/'+logo" alt=""></v-img>
        </router-link>

        <v-col cols="1" class="px-0 p-f d-none d-lg-flex">
          <div class="bg-dark-c pa-6  pt-0">
            <router-link :to="'/?lang='+$i18n.locale">
              <div class="logo d-flex">
                <img :src="'/assets/img/moharam/logo.svg'">
              </div>
            </router-link>
            
            <!-- 
            <div class="list">
              <div @click="scrollToSection('mewakeb')" class="d-flex flex-column pointer">
                <div class="ico mx-auto"><svg viewBox="0 0 24 24" style="height: 24px;">
                    <use xlink:href="/assets/img/moharam/clock2.svg#view"></use>
                  </svg></div>
                <h6 class="text-white text-center">{{ $t('mewakeb_data') }}</h6>
              </div>
            </div> -->

            <div class="list d-flex">
              <div @click="scrollToSection('live')" class="d-flex flex-column pointer">
                <!-- <div class="ico2 mx-auto">
                  <img src="/assets/img/moharam/antenna.png">

                </div> -->

                <div class="ico2 mx-auto"><svg viewBox="3 2 23 24" style="height: 24px;">
                    <use xlink:href="/assets/img/moharam/live2.svg#view"></use>
                  </svg></div>
                <h6 class="text-white text-center">{{ $t('index_live') }}</h6>
              </div>
            </div>
<!-- 
            <div class="list d-flex" v-if="lang=='ar'">
              <div @click="scrollToSection('stats')" class="d-flex flex-column pointer">
                <div class="ico mx-auto"><svg viewBox="1 0 23 24" style="height: 24px;">
                    <use xlink:href="/assets/img/moharam/clipboard2.svg#view"></use>
                  </svg></div>

            
                <h6 class="text-white text-center">{{ $t('muharram_stats') }}</h6>
              </div>
            </div> -->

            <div class="list d-flex">
              <div @click="scrollToSection('visitor')" class="d-flex flex-column pointer">
                <!-- <div class="ico2 mx-auto" >
                  <img src="/assets/img/moharam/your-location.png">

                </div> -->

                <div class="ico2 mx-auto">
                  <img class="mx-auto" :src="'/assets/img/moharam/map-pin.svg'" style="height: 28px !important;">
                </div>


                <h6 class="text-white text-center">{{ $t('visitor_guide') }}</h6>
              </div>
            </div>
            
            <div class="list d-flex">
              <div @click="scrollToSection('ashab')" class="d-flex flex-column pointer">
                <!-- <div class="ico2 mx-auto" >
                  <img src="/assets/img/moharam/your-location.png">

                </div> -->

                <div class="ico2 mx-auto">
                  <img class="mx-auto" :src="'/assets/img/moharam/ashab.svg'" style="height: 36px !important;">
                </div>


                <h6 class="text-white text-center">   {{ $t('CompanionsـHussein') }}</h6>
              </div>
            </div>
            <div class="list d-flex">
              <div @click="scrollToSection('khdham')" class="d-flex flex-column pointer">
                <!-- <div class="ico2 mx-auto" >
                  <img src="/assets/img/moharam/your-location.png">

                </div> -->

                <div class="ico2 mx-auto">
                  <img class="mx-auto" :src="'/assets/img/moharam/muslim.png'" style="height: 32px !important;">
                </div>
                

                <h6 class="text-white text-center">  {{ $t('Servants_Hussein') }}</h6>
              </div>
            </div>



            <!-- <div class="list d-flex"  v-if="lang=='ar'">
              <div @click="scrollToSection('events')" class="d-flex flex-column pointer">
                <div class="ico mx-auto"><svg viewBox="1 0 23 24" style="height: 24px;">
                    <use xlink:href="/assets/img/moharam/calendar2.svg#view"></use>
                  </svg></div>
                <h6 class="text-white text-center">{{$t('today_events')}}</h6>
              </div>
            </div> -->

            <div class="list d-flex">
              <div @click="scrollToSection('enabaa')" class="d-flex flex-column pointer">
                <!-- <div class="ico2 mx-auto">
                  <img src="/assets/img/moharam/beads.png">

                </div> -->

                <div class="ico2 mx-auto"><svg viewBox="0 0 24 24" style="height: 32px;">
                    <use xlink:href="/assets/img/moharam/enabaa2.svg#view"></use>
                  </svg></div>

                <h6 class="text-white text-center">{{$t('index_zyara')}}</h6>
              </div>
            </div>

            


          </div>
        </v-col>
        <v-col cols="12" class="px-0">
          <div class="">




            <v-container class="mx-w" style="max-width: 1400px"   pa-6>

              <a :href="'https://alkafeel.net/zyara?lang=' + $i18n.locale" class="title" id="enabaa">
                <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                <span class="ab_title tl"
                  style="cursor: pointer;font-size: 24px;font-weight: 700; color:#fff">{{$t('index_zyara')}}</span>
              </a>
              <v-layout row class="r-dd">

                <v-img :gradient="$vuetify.theme.dark ? 'to bottom' : ''"
                  :max-height="$vuetify.breakpoint.mdAndUp ? '300px' : ''">

                  <v-layout row class="live mx-auto" my-2>
                    <p class="zyara_cat tl text-center" style="width:100%">{{ zyaraData.title }}</p>
                  </v-layout>

                  <v-form ref="form" v-model="valid">
                    <v-layout row mb-8 class="live mx-auto">
                      <v-flex sm5 pa-2>
                        <v-text-field v-model="zeara_i.name" solo flat color="success" :placeholder="$t('zyara_ab')"
                          hide-details="auto" :rules="[rules.required]"></v-text-field>
                      </v-flex>
                      <v-flex sm5 pa-2>
                        <v-text-field v-model="zeara_i.email" solo flat color="success"
                          :placeholder="$t('msg_email_optional')" hide-details="auto" :rules="[rules.email]">
                        </v-text-field>
                      </v-flex>
                      <v-flex sm2 pa-2>
                        <v-btn min-height="40px" width="100%" max-height="50px" height="100%" class="tl white--text"
                          :loading="loading" color="#B1BD52" @click="zyara_send()">
                          <p class="tl text-dark mb-0">{{ $t('action_send') }}</p>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>

                </v-img>
              </v-layout>







              <v-layout row mt-12 id="live">
                <router-link :to="'/stream?lang='+$i18n.locale" class="title">
                  <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                  <span class="ab_title tl"
                    style="cursor: pointer;font-size: 24px;font-weight: 700; color:#fff">{{$t('index_live')}}</span>
                </router-link>

                <v-layout row class="r-dd">
                  <!-- <v-flex sm1 md1  d-none d-sm-flex>
                  </v-flex> -->
                  <v-flex sm9 xs12 style="position: relative;">
                    <div class="player_wrap mt-2 px-4">
                      <v-skeleton-loader v-if="playerLoading" style="height:100%" v-bind="attrs" type="image">
                      </v-skeleton-loader>
                      <video v-show="!playerLoading" ref="videoPlayer" class="video-js vjs-theme-dt vjs-costum"></video>
                    </div>
                  </v-flex>






                  <v-flex sm12 xs12 md3 px-4 class="comments">

                    <!-- <v-layout row style="max-height:550px; overflow-y:auto"> -->
                    <v-layout row>
                      <v-flex pa-3 md12 sm4 w-100 v-for="source in live" :key="source">
                        <v-img @click="playSrc(source.src, source.pic, source.title, source.id)" min-height="55"
                          class="cam_btn" :class="activeId === source.id ? 'cam_active' : ''"
                          :style="$vuetify.rtl ? '' : 'padding: 15px 0 15px 25%;'">
                          <div class="play1 hidden-md-and-down" :class="$vuetify.rtl ? '' : 'play_ltr'"><svg
                              viewBox="0 0 35 25">
                              <use xlink:href="/assets/img/live/cam.svg#view"></use>
                            </svg></div>
                          <span class="text-white">{{source.title}}</span>
                        </v-img>

                        <!-- <v-img @click="playSrc(source.src, source.pic, source.title, source.id)" max-height="124px" :src="'https://alkafeel.net/live/images/resize/'+source.pic">
                                   <div class="play"><img :class="source.id" :src="activeId === source.id ? '/assets/img/pause_icon.svg' : '/assets/img/play_icon.svg'" /></div>
                               </v-img>
                               <p class="t1 text-center" style="color: #fff;     position: sticky;;">{{source.title}}</p> -->

                      </v-flex>

                      <v-flex pa-3 w-100 v-for="source in atabat" :key="source">
                        <v-img
                          @click="playSrc(source.src, source.pic, source.title, source.id, source.stream_type, true)"
                          min-height="55" class="cam_btn" :class="activeId === source.id ? 'cam_active' : ''"
                          :style="$vuetify.rtl ? '' : 'padding: 15px 0 15px 25%;'">

                          <div class="play1 hidden-md-and-down" :class="$vuetify.rtl ? '' : 'play_ltr'"><svg
                              viewBox="0 0 35 25">
                              <use xlink:href="/assets/img/live/cam.svg#view"></use>
                            </svg></div>
                          <span class="text-white">{{source.title}}</span>
                        </v-img>
                      </v-flex>


                    </v-layout>

                  </v-flex>


                </v-layout>
              </v-layout>


              <template v-if="lang == 'ar' && events !=null">
                <v-layout row mt-12 id="events">
                  <div class="title">
                    <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                    <span class="ab_title tl"
                      style="font-size: 24px;font-weight: 700; color:#fff">{{$t('today_events')}}</span>
                  </div>
                </v-layout>


                <v-layout row>
                  <div class="events px-6 pt-6 pb-6"
                    style="width: 100%; white-space:pre-wrap;text-align: center;font-size: 20px;">
                    {{ events }}
                  </div>
                </v-layout>
              </template>



              <!-- <v-main>
      <breaking-news></breaking-news>
    </v-main> -->


              <div>

                <v-container fluid class="relative my-10" id="ashab">

                  <br>
                <router-link class="title"  :to="'/muharram?lang='+$i18n.locale" style="    text-decoration: none;">
                  <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                  <span class="ab_title tl"
                    style="cursor: pointer;font-size: 24px;font-weight: 700; color:#fff">     {{ $t('CompanionsـHussein') }} </span>
                </router-link>
                  <v-row class="custom-section" style="direction: inherit;">
                    <v-col cols="1"></v-col>
                    <v-col cols="12" md="5" class="custom-content">
                      <h1 class="custom-title pa-4 rounded" id="title">{{ currentTitle }}</h1>
                      <p class="custom-description" style="white-space: pre-wrap"  id="description">{{ currentDescription }}</p>
                    </v-col>
                    <v-col cols="12" md="6" class="custom-card-container">
                      <div class="relative more-cu">
                        <div v-for="(card, index) in cards" :key="index" class="custom-card"
                          :style="{ transform: `rotate(${index === 0 ? -10 : (index === 1 ? 10 : -5)}deg)`, zIndex: index === 1 ? 2 : 1 }">
                          <img :src="card.image.replace('/thumb/', '/thumb2/')" :alt="`صورة ${index + 1}`">
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div class="custom-arrows">
                    <button class="custom-arrow" @click="showPrev">
                      <img src='/assets/img/moharam/arrow-right.svg'>
                    </button>
                    <button class="custom-arrow" @click="showNext">
                      <img src='/assets/img/moharam/arrow-left.svg'>

                    </button>
                  </div>
                </v-container>

              </div>

              <section class="khdham" id="khdham">
                <div class="relative">
                  <!-- <h2>خدام الحسين</h2> -->

                  <a :href="'https://alkafeel.net/muharram/?lang=ar'" class="title" id="khdham">
                 
                  <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                  <span class="ab_title tl" style="cursor: pointer;font-size: 24px;font-weight: 700; color:#fff"> 	   {{ $t('Servants_Hussein') }}   </span>
                  </a>

                </div>
                <span class="bg-watermark">يا حسين</span>
                <!-- <v-container>
                  <v-row align="center" justify="center">

                    <template v-for="(data, i) in khudam">
                      <v-col cols="12" md="4">
                        <div class="cards" :class="{ 'uni-2': (i == 1) } ">
                          <div class="card" @click="openModal('modal',data)">
                            <img :src="data.image">
                            <div class="card-content">
                              <h3>{{ data.title }}</h3>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>


                  </v-row>
                </v-container> -->





                
                
                <template v-if="khudam.length">
                  <VueSlickCarousel v-bind="settings">
                    <div v-for="(data, i) in khudam">
                      <div class="cards mx-3 mb-8" :class="{ 'uni-2': (i % 2) } ">
                        <div class="card" @click="openModal('modal',data)">
                          <img :src="data.image">
                          <div class="card-content">
                            <h3>{{ data.title }}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template #prevArrow="arrowOption">
                      <div class="custom-arrow2">
                      </div>
                    </template>
                    <template #nextArrow="arrowOption">
                      <div class="custom-arrow2">
                      </div>
                    </template>
                  </VueSlickCarousel>
                </template>

                <br> <br>
                

 

 


                <div>

                  <v-btn class="bg-red text-white" style="padding: 28px; white-space: normal; text-align: right;width:100%;display: contents;" @click="open_ashs();">
                    <span class="button-text1">
                      <div>
                        <svg viewBox="0 0 24 24" style="height: 32px; fill: #fff; margin: 0 8px;">
                        <use xlink:href="/assets/img/moharam/enabaa2.svg#view"></use>
                    </svg>
                      </div>
                    
                    {{$t("Dedicating_reward_reciting_ Ashura_visit_the souls_serving_Hussein")}} 
                    </span>
                  </v-btn>



                  <v-dialog v-model="open_ash" max-width="1000" class="dirr"  style="background-color: #fff !important">
                  <v-card class="Contact_dialog">
                    <v-btn class="closeBtn" @click="open_ash = false" color="red" style="margin:20px 20px 0 20px;" fab small
                      dark>
                      <span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M0.898438 0.0796127C0.242188 0.26702 -0.164062 1.10254 0.078125 1.76628C0.125 1.88341 1.96094 3.78091 4.16406 5.98295L8.16406 9.98878L4.20312 13.9478C0.171875 17.977 0 18.18 0 18.7345C0 19.2889 0.5 19.8667 1.04688 19.9604C1.76562 20.0775 1.58594 20.2181 5.96094 15.8609L10 11.8238L14.0469 15.8609C18.4141 20.2181 18.2344 20.0775 18.9531 19.9604C19.5 19.8667 20 19.2889 20 18.7345C20 18.18 19.8281 17.977 15.7969 13.9478L11.8359 9.98878L15.8359 5.98295C18.0391 3.78091 19.875 1.88341 19.9219 1.76628C20.1406 1.17282 19.8594 0.470045 19.2969 0.173317C18.8984 -0.0375164 18.625 -0.053134 18.2188 0.110847C18.0234 0.196743 16.6953 1.46955 13.9688 4.19477L10 8.15375L6.03906 4.19477C3.30469 1.46955 1.97656 0.196743 1.78125 0.110847C1.46094 -0.0218994 1.25 -0.0297082 0.898438 0.0796127Z"
                            fill="white" />
                        </svg>
                      </span>
                    </v-btn>

          <div class="Tbody">

            <v-layout row>


              <v-flex xs12 sm12 md12 lg12 style="">
                
                <p class="tl adress">{{$t("Dedicating_reward_reciting_ Ashura_visit_the souls_serving_Hussein")}} </p>
              </v-flex>


              <v-flex xs12 sm12 md12 lg12 style="">
                <p class="tl adress">نص الزيارة</p>
              </v-flex>

            
              <p style="padding: 40px;" class="tl adress">{{ shour }}</p>

           

            
            </v-layout>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="letter-spacing: normal;" color="red darken-1" text @click="open_ash = false">{{$t("close")}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



                  <v-dialog v-model="amd_dialog" max-width="1000" class="dirr" style="background-color: #fff !important">
        <v-card class="Contact_dialog">
          <v-btn class="closeBtn" @click="amd_dialog = false" color="red" style="margin:20px 20px 0 20px;" fab small
            dark>
            <span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.898438 0.0796127C0.242188 0.26702 -0.164062 1.10254 0.078125 1.76628C0.125 1.88341 1.96094 3.78091 4.16406 5.98295L8.16406 9.98878L4.20312 13.9478C0.171875 17.977 0 18.18 0 18.7345C0 19.2889 0.5 19.8667 1.04688 19.9604C1.76562 20.0775 1.58594 20.2181 5.96094 15.8609L10 11.8238L14.0469 15.8609C18.4141 20.2181 18.2344 20.0775 18.9531 19.9604C19.5 19.8667 20 19.2889 20 18.7345C20 18.18 19.8281 17.977 15.7969 13.9478L11.8359 9.98878L15.8359 5.98295C18.0391 3.78091 19.875 1.88341 19.9219 1.76628C20.1406 1.17282 19.8594 0.470045 19.2969 0.173317C18.8984 -0.0375164 18.625 -0.053134 18.2188 0.110847C18.0234 0.196743 16.6953 1.46955 13.9688 4.19477L10 8.15375L6.03906 4.19477C3.30469 1.46955 1.97656 0.196743 1.78125 0.110847C1.46094 -0.0218994 1.25 -0.0297082 0.898438 0.0796127Z"
                  fill="white" />
              </svg>
            </span>
          </v-btn>

          <div class="Tbody">

            <v-layout row>

              <v-flex xs12 sm12 md12 lg12 style="">
                <img :src="Amd.image" class="modal_image">
                <p class="tl adress">{{ Amd.title }}</p>
              </v-flex>
              <p class="text-khdham tl" v-html="bbcode(Amd.description)" ></p>

           

            
            </v-layout>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="letter-spacing: normal;" color="red darken-1" text @click="amd_dialog = false">{{$t("close")}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
            

             
                </div>

              </section>




              





              <!-- <v-layout row id="mewakeb">
                <div class="title mt-12">
                  <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                  <span class="ab_title tl"
                    style="font-size: 24px;font-weight: 700; color:#fff">{{$t('mewakeb_data')}}</span>
                </div>
              </v-layout>

              <v-layout row>
                <div class="text-center">
                  <v-btn class="px-16 mx-10 my-3" v-for="index in 9"
                    :style="today == index ? {'background-color':'rgb(170, 0, 0)'}: {}" dark @click="data_tbl(index)">
                    {{ index }} {{ $t('muharram') }} </v-btn>
                </div>
              </v-layout>

              <v-layout row>
                <div class="text-center" style="width:100%">
                  <v-btn class="px-16 mx-10 my-3" dark @click="data_tbl2()"> مواكب عزاء اللطم </v-btn>
                </div>
              </v-layout> -->






<!-- 
              <template v-if="lang == 'ar'"   style="display:none">
                <v-layout row id="stats">
                  <div class="title mt-12">
                    <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                    <span class="ab_title tl" style="font-size: 24px;font-weight: 700; color:#fff">احصائيات شهر محرم
                      لسنة
                      2023</span>
                  </div>
                </v-layout>

                <v-layout row class="r-dd" style="    display: none;">
                  <div class="events pa-6" style="width: 100%">
                    <div class="main-stats">
                      <div class="d-flex flex-column pointer">
                        <img class="mx-auto ico-cu " :src="'/assets/img/moharam/user.svg'">
                        <h2 class="text-white text-center b-bottom">
                          <number ref="number1" :from="3134881" :to="4134881" :format="theFormat" :duration="6"
                            :delay="3" />
                        </h2>
                        <h4 class="text-white text-center py-2">اكثر من اربعة ملايين زائر</h4>
                      </div>
                      <div class="d-flex flex-column pointer">
                    <img class="mx-auto" :src="'/assets/img/moharam/mawkeb.svg'">
                    <h2 class="text-white text-center b-bottom">
                      <number
    ref="number1"
	:from="0"
	:to="11"
	:format="theFormat"
	:duration="6"
    :delay="0.1"
    />
                       </h2>
                    <h4 class="text-white text-center py-2">الف موكب</h4>
                  </div>
                  
                      <div class="d-flex flex-column pointer">
                        <img class="mx-auto ico-cu " :src="'/assets/img/moharam/food.svg'">
                        <h2 class="text-white text-center b-bottom">
                          <number ref="number1" :from="3134881" :to="21198640 " :format="theFormat" :duration="6"
                            :delay="3" />
                        </h2>
                        <h4 class="text-white text-center py-2"> واحـد وعشرين مليونـاً 
                          وجبة
                          </h4>
                      </div>
                      <div class="d-flex flex-column pointer">
                        <img class="mx-auto ico-cu " :src="'/assets/img/moharam/droplet.svg'">
                        <h2 class="text-white text-center b-bottom">


                          <number ref="number1" :from="3134881" :to="63000000 " :format="theFormat" :duration="6"
                            :delay="3" />
                        </h2>
                        <h4 class="text-white text-center py-2">ثلاثة وستون مليون لتر </h4>
                      </div>
                    </div>
                  </div>
                </v-layout>
                <v-col cols="4"> 
                 <div class="dalel-img">
                   <img class="mx-auto" :src="'/assets/img/moharam/md.jpg'"> 
                 </div>
                 <div>
                   <h4 class="text-white">
                     عدد المواكب في شهر محرم
                   </h4>
                 </div>
               </v-col>

              </template> -->



              <v-layout row id="visitor" class="r-dd">
                <div class="title mt-12">
                  <span style="padding:0 10px; content: url('/assets/img/moharam/z-mohammed.svg')"></span>
                  <span class="ab_title tl"
                    style="font-size: 24px;font-weight: 700; color:#fff">{{$t('visitor_guide')}}</span>
                </div>
              </v-layout>

              <v-container class="custom-size">
                <template>
                <v-card class="transparent">
                  <v-toolbar color="#303030" flat>
                    <!-- <v-text-field append-icon="mdi-microphone" autofocus="true" class="guid-search mx-4" flat hide-details  color="red" dark  style="color:#fff !important"
                     placeholder="ابحث عن الوجهة التي تحتاجها" prepend-inner-icon="mdi-magnify" solo-inverted></v-text-field> -->


                    <v-text-field v-model="search" @change="searchs" @keyup.enter="search" solo flat dark
                      color="success" :label="$t('visitor_guide_search')" hide-details="auto" outlined
                      :rules="SearchRules">

                      <v-btn color="#14A79D" slot="append" @click="searchs();page=1">{{$t('search')}}
                        <div class="serv" style="padding-top:3px"><svg viewBox="0 0 26 25">
                            <use xlink:href="/assets/img/services/search.svg#view"></use>
                          </svg></div>
                      </v-btn>
                    </v-text-field>


                    <template v-slot:extension>
                      <v-tabs v-model="tabs" centered dark>
                        <v-tab v-for="PlacesCat in PlacesCats" :key="PlacesCat"
                          @click="getPlace(PlacesCat.category_id,page=1,is_search=false)">
                          {{ PlacesCat.category_name }}
                        </v-tab>
                      </v-tabs>
                    </template>
                  </v-toolbar>

                  <v-tabs-items v-model="tabs" class="main-table ">

                    <v-tab-item v-for="PlacesCat in PlacesCats" :key="PlacesCat">
                      <v-card flat class="transparent border">

                        <v-card-title class="text-h5 text-white" v-if="!is_search">
                          {{ PlacesCats[tabs].category_name }}

                        </v-card-title>

                        <v-card-title class="text-h5" v-else>
                          نتائج البحث

                        </v-card-title>


                        <v-layout row wrap pa-4>
                          <template v-for="Guid in Guids">
                            <v-flex xs12 md3 sm3 
                              @click="show(Guid.place_name,Guid.place_address,'', Guid.place_lat,Guid.place_lng)">
                              <div class="location-div d-flex">

                                <div class="sub-location">
                                  <div class="l-img">
                                    <img class="mx-auto" :src="'/assets/img/moharam/pin.svg'">

                                  </div>
                                  <div class="l-text text-center">
                                    <h5 style="color: #fff;" v-if="Guid.place_name"> {{ Guid.place_name }}</h5>
                                    <h5 style="color: #fff;" v-else> {{ Guid.title }}</h5>
                                    <span class="l-color" v-if="Guid.place_address"> {{ Guid.place_address }}</span>
                                    <span class="l-color" v-else> {{ Guid.caption }}</span>
                                  </div>
                                </div>

                                <div class="icons d-flex d-sm-none">
                                  <img class="mx-auto" :src="'/assets/img/moharam/chevron-left.svg'">
                                </div>

                              </div>


                            </v-flex>
                          </template>
                        </v-layout>
                        <v-pagination v-model="page" :length="pageCount" @input="next"></v-pagination>

                      </v-card>
                    </v-tab-item>

                  </v-tabs-items>
                </v-card>
              </template>
              </v-container>
              
              <v-layout row class="r-dd">




                <!-- <template v-for="s in address">
                  <v-flex lg4 pa-6 @click="show(s.title,s.address,s.phone, s.coord)">
                    <v-img :src="'/assets/img/moharam/'+s.img" style="max-height: 195px;" class="sec">
                      <div class="fill-height gradiant_img pt-16">
                        <img height="35" style="cursor:pointer;" src="/assets/img/moharam/location.svg">
                        <div class="text-center text-white">اضغط للعرض على الخارطة</div>
                      </div>
                    </v-img>
                    <div class="text-center mt-3 tyu">{{ s.title }}</div>
                  </v-flex>
                </template> -->



              </v-layout>

            </v-container>





          </div>
        </v-col>
      </v-row>



      <!-- <v-dialog v-model="dialog" max-width="1000" class="dirr">
        <v-card class="Contact_dialog" style="min-width: 420px;">
          <v-btn class="closeBtn" @click="dialog = false" color="red" style="margin:20px 20px 0 20px;" fab small dark>
            <span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.898438 0.0796127C0.242188 0.26702 -0.164062 1.10254 0.078125 1.76628C0.125 1.88341 1.96094 3.78091 4.16406 5.98295L8.16406 9.98878L4.20312 13.9478C0.171875 17.977 0 18.18 0 18.7345C0 19.2889 0.5 19.8667 1.04688 19.9604C1.76562 20.0775 1.58594 20.2181 5.96094 15.8609L10 11.8238L14.0469 15.8609C18.4141 20.2181 18.2344 20.0775 18.9531 19.9604C19.5 19.8667 20 19.2889 20 18.7345C20 18.18 19.8281 17.977 15.7969 13.9478L11.8359 9.98878L15.8359 5.98295C18.0391 3.78091 19.875 1.88341 19.9219 1.76628C20.1406 1.17282 19.8594 0.470045 19.2969 0.173317C18.8984 -0.0375164 18.625 -0.053134 18.2188 0.110847C18.0234 0.196743 16.6953 1.46955 13.9688 4.19477L10 8.15375L6.03906 4.19477C3.30469 1.46955 1.97656 0.196743 1.78125 0.110847C1.46094 -0.0218994 1.25 -0.0297082 0.898438 0.0796127Z"
                  fill="white" />
              </svg>
            </span>
          </v-btn>

          <div class="Thead d-none d-sm-flex">
            <v-layout row>
              <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                <p class="tl">اسم الموكب</p>
              </v-flex>
              <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                <p class="tl">الوصول الى صحن العباس </p>
              </v-flex>
              <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                <p class="tl">مكان الانطلاق</p>
              </v-flex>
              <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                <p class="tl">مكان الختام</p>
              </v-flex>
            </v-layout>
          </div>
          <div class="Tbody">
            <div class="divInfo" v-for="i in divInfo" :key="i">
              <v-layout row>
                <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                  <p class="tl">{{ i.name }}</p>
                </v-flex>
                <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                  <p class="tl">{{ i.hour }}</p>
                </v-flex>
                <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                  <p class="tl"> {{ i.start_loc }}</p>
                </v-flex>
                <v-flex xs3 sm3 md3 lg3 style="padding:10px;">
                  <p class="tl"> {{ i.end_loc }}</p>
                </v-flex>
              </v-layout>
            </div>

          </div>

           <horizontal-scroll>
                    <div class="container-fluid alkafeel_photos_container"  >

                        <div class="dragscroll" v-hscroll id="alkafeel_photos_cont"  style="overflow-x: scroll;" >
                            <div id="alkafeel_photos_wrap"  style="width:3000px!important">


                                <div class="alkafeel_photos_block" >
                                    <a v-for="(photo,index) in ssc.slice(0, 6)" :key="index" :href="'/image/'+photo.id">

                                        <div :class="'alkafeel_pics_layout'+(index+1)+ ' lazy'"
                                            :data-src="'https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)"
                                            data-was-processed="true"
                                            :style="'background-image: url(&quot;https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)+'&quot;);'">
                                        </div>


                                    </a>
                                </div>

                                <div class="alkafeel_photos_block">
                                    <a v-for="(photo,index) in ssc.slice(6, 12)" :key="index"
                                        :href="'/image/'+photo.id">

                                        <div :class="'alkafeel_pics_layout'+(index+1)+ ' lazy'"
                                            :data-src="'https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)"
                                            data-was-processed="true"
                                            :style="'background-image: url(&quot;https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)+'&quot;);'">
                                        </div>
                                    </a>
                                </div>




                                <div class="alkafeel_photos_block">
                                    <a v-for="(photo,index) in ssc.slice(12, 18)" :key="index"
                                        :href="'/image/'+photo.id">

                                        <div :class="'alkafeel_pics_layout'+(index+1)+ ' lazy'"
                                            :data-src="'https://alkafeel.tv/static/uploads/gallerywebp/'+rep(photo.filename)"
                                            data-was-processed="true"
                                            :style="'background-image: url(&quot;https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)+'&quot;);'">
                                        </div>
                                    </a>
                                </div>
                                <div class="alkafeel_photos_block">
                                    <a v-for="(photo,index) in ssc.slice(18, 24)" :key="index"
                                        :href="'/image/'+photo.id">

                                        <div :class="'alkafeel_pics_layout'+(index+1)+ ' lazy'"
                                            :data-src="'https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)"
                                            data-was-processed="true"
                                            :style="'background-image: url(&quot;https://alkafeel.tv/static/uploads/gallery/webp/'+rep(photo.filename)+'&quot;);'">
                                        </div>
                                    </a>
                                </div>
                                <a href="https://alkafeel.tv/gallery/20" class="more">
                                    <div>
                                    <span class="text-white">للمزيد تابع</span>
                                    <i class="fas fa-chevron-left mr-2"></i>
                                </div>
                                </a>






                            </div>
                        </div>
                    </div>
                </horizontal-scroll> -->
      <!-- <v-card-text>
             {{modal_data}}
           </v-card-text> -->
      <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="letter-spacing: normal;" color="red darken-1" text @click="dialog = false">{{$t("close")}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->


      <v-dialog v-model="dialog2" max-width="1000" class="dirr">
        <v-card class="Contact_dialog">
          <v-btn class="closeBtn" @click="dialog2 = false" color="red" style="margin:20px 20px 0 20px;" fab small dark>
            <span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.898438 0.0796127C0.242188 0.26702 -0.164062 1.10254 0.078125 1.76628C0.125 1.88341 1.96094 3.78091 4.16406 5.98295L8.16406 9.98878L4.20312 13.9478C0.171875 17.977 0 18.18 0 18.7345C0 19.2889 0.5 19.8667 1.04688 19.9604C1.76562 20.0775 1.58594 20.2181 5.96094 15.8609L10 11.8238L14.0469 15.8609C18.4141 20.2181 18.2344 20.0775 18.9531 19.9604C19.5 19.8667 20 19.2889 20 18.7345C20 18.18 19.8281 17.977 15.7969 13.9478L11.8359 9.98878L15.8359 5.98295C18.0391 3.78091 19.875 1.88341 19.9219 1.76628C20.1406 1.17282 19.8594 0.470045 19.2969 0.173317C18.8984 -0.0375164 18.625 -0.053134 18.2188 0.110847C18.0234 0.196743 16.6953 1.46955 13.9688 4.19477L10 8.15375L6.03906 4.19477C3.30469 1.46955 1.97656 0.196743 1.78125 0.110847C1.46094 -0.0218994 1.25 -0.0297082 0.898438 0.0796127Z"
                  fill="white" />
              </svg>
            </span>
          </v-btn>

          <v-img src="https://alkafeel.net/news/images/attach/20100-5c2d693334689ceb63380b.png"></v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="letter-spacing: normal;" color="red darken-1" text @click="dialog2 = false">{{$t("close")}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="map_dialog" max-width="1000" class="dirr">
        <v-card class="Contact_dialog">
          <v-btn class="closeBtn" @click="map_dialog = false" color="red" style="margin:20px 20px 0 20px;" fab small
            dark>
            <span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.898438 0.0796127C0.242188 0.26702 -0.164062 1.10254 0.078125 1.76628C0.125 1.88341 1.96094 3.78091 4.16406 5.98295L8.16406 9.98878L4.20312 13.9478C0.171875 17.977 0 18.18 0 18.7345C0 19.2889 0.5 19.8667 1.04688 19.9604C1.76562 20.0775 1.58594 20.2181 5.96094 15.8609L10 11.8238L14.0469 15.8609C18.4141 20.2181 18.2344 20.0775 18.9531 19.9604C19.5 19.8667 20 19.2889 20 18.7345C20 18.18 19.8281 17.977 15.7969 13.9478L11.8359 9.98878L15.8359 5.98295C18.0391 3.78091 19.875 1.88341 19.9219 1.76628C20.1406 1.17282 19.8594 0.470045 19.2969 0.173317C18.8984 -0.0375164 18.625 -0.053134 18.2188 0.110847C18.0234 0.196743 16.6953 1.46955 13.9688 4.19477L10 8.15375L6.03906 4.19477C3.30469 1.46955 1.97656 0.196743 1.78125 0.110847C1.46094 -0.0218994 1.25 -0.0297082 0.898438 0.0796127Z"
                  fill="white" />
              </svg>
            </span>
          </v-btn>

          <div class="Tbody">

            <v-layout row>

              <v-flex xs12 sm12 md12 lg12 style="">
                <p class="tl adress">{{ devAddress }}</p>
              </v-flex>


              <v-flex xs12 sm12 md12 lg12 style="">
                <p class="tl adress">{{ add }} </p>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 style="">
                <p class="tl adress">{{ phone }}</p>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 style="padding:10px 20px 20px 20px;">
                <div class="gmap">
                  <GmapMap :options="mapOptions" :center="coordinates" :zoom="17" map-type-id="roadmap"
                    style="width: 100%; height: 100%">
                    <gmap-marker :position="coordinates"></gmap-marker>
                  </GmapMap>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="letter-spacing: normal;" color="red darken-1" text @click="map_dialog = false">{{$t("close")}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-app>
  </div>
  </template>

  <style>
    .tyu {
      position: absolute;
      text-align: center !important;
      color: #fff;
      font-size: 19px;
      padding-right: 5%;
      font-weight: bold;

    }

    @media screen and (min-width: 800px) {
      .r-dd {
        padding-right: 70px;
        padding-left: 120px;
      }

    }
  </style>
  <script>
    import BreakingNews from '@/components/home/BreakingNews.vue';
    import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'
    import videojs from 'video.js';
    import 'videojs-youtube';
    import bbCodeParser from 'js-bbcode-parser';
    import 'video.js/dist/video-js.min.css';
    import '@digitaltheatre/videojs-theme-dt/dist/theme/index.css';
    import Swal from "sweetalert2";

    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
      name: 'VideoPlayer',
      data() {
        return {
          dialog: false,
          languages: [
            { name: 'العربية' },
            { name: 'English' },
            { name: 'Deutsch' },
            { name: 'Français' },
            { name: 'Türkçe' },
            { name: 'Español' },
            { name: 'فارسی' },
            { name: 'اردو' },
            { name: 'Kiswahili' }
          ],

          tabs: 0,
          shour:'اَلسَّلامُ عَلَيْكَ يَا أَبَا عَبْدِ اللهِ ، اَلسَّلامُ عَلَيْكَ يَا بْنَ رَسُولِ اللهِ (اَلسَّلامُ عَلَيْكَ يَا خِيَرَةَ اللهِ وَابْنَ خِيَرَتِهِ ) اَلسَّلامُ عَلَيْكَ يَا بْنَ أَميرِ الْمُؤْمِنِينَ وَابْنَ سَيِّدِ الْوَصِيِّينَ ، اَلسَّلامُ عَلَيْكَ يَا بْنَ فاطِمَةَ سَيِّدَةِ نِسَاءِ الْعَالَمِينَ ، اَلسَّلامُ عَلَيْكَ يَا ثَأْرَ اللهِ وَابْنَ ثَأْرِهِ وَالْوِتْرَ الْمَوْتُورَ ، اَلسَّلامُ عَلَيْكَ وَعَلَى الْأَرْوَاحِ الَّتِي حَلَّتْ بِفِنَائِكَ ، عَلَيْكُم مِّنِّي جَمِيعاً سَلامُ اللهِ أَبَداً مَّا بَقِيتُ وَبَقِيَ اللَّيْلُ وَالنَّهَارُ ، يَا أَبَا عَبْدِ اللهِ لَقَدْ عَظُمَتِ الرَّزِيَّةُ وَجَلَّتْ ، وَعَظُمَتِ الْمُصِيبَةُ بِكَ عَلَيْنا وَعَلَى جَمِيعِ أَهْلِ الْإِسْلَامِ ، وَجَلَّتْ وَعَظُمَتْ مُصِيبَتُكَ فِي السَّمَاوَاتِ عَلَى جَمِيعِ أَهْلِ السَّمَاوَاتِ ، فَلَعَنَ اللهُ أُمَّةً أَسَّسَتْ أَسَاسَ الظُّلْمِ وَالْجَوْرِ عَلَيْكُمْ أَهْلَ الْبَيْتِ ، وَلَعَنَ اللهُ أُمَّةً دَفَعَتْكُمْ عَن مَّقامِكُمْ وَأَزالَتْكُمْ عَن مَّراتِبِكُمُ الَّتي رَتَّبَكُمُ اللهُ فِيهَا ، وَلَعَنَ اللهُ أُمَّةً قَتَلَتْكُمْ وَلَعَنَ اللهُ الْمُمَهِّدِينَ لَهُمْ بِالتَّمْكِينِ مِنْ قِتَالِكُمْ ، بَرِئْتُ إِلَى اللهِ وَإِلَيْكُمْ مِنْهُمْ وَمِنْ أَشْيَاعِهِمْ وَأَتْبَاعِهِمْ وَأَوْلِيَائِهِم ، يَا أَبَا عَبْدِ اللهِ إِنِّي سِلْمٌ لِمَنْ سَالَمَكُمْ وَحَرْبٌ لِّمَنْ حَارَبَكُمْ إِلَى يَوْمِ الْقِيَامَةِ ، وَلَعَنَ اللهُ آلَ زِيَادٍ وَّآلَ مَرْوَانَ ، وَلَعَنَ اللهُ بَنِي أُمَيَّةَ قَاطِبَةً ، وَّلَعَنَ اللهُ ابْنَ مَرْجَانَةَ ، وَلَعَنَ اللهُ عُمَرَ بْنَ سَعْدٍ ، وَّلَعَنَ اللهُ شِمْراً ، وَّلَعَنَ اللهُ أُمَّةً أَسْرَجَتْ وَأَلْجَمَتْ وَتَنَقَّبَتْ لِقِتَالِكَ ، بِأَبِي أَنْتَ وَأُمِّي لَقَدْ عَظُمَ مُصَابِي بِكَ ، فَأَسْأَلُ اللهَ الَّذِي أَكْرَمَ مَقَامَكَ وَأَكْرَمَنِي بِكَ أَن يَّرْزُقَنِي طَلَبَ ثَأْرِكَ مَعَ إِمَامٍ مَّنْصُورٍ مِنْ أَهْلِ بَيْتِ مُحَمَّدٍ ـ صَلَّى اللهُ عَلَيْهِ وَآلِهِ ـ ، اَللَّهُمَّ اجْعَلْنِي عِنْدَكَ وَجيهاً بِالْحُسَيْنِ ـ عَلَيْهِ السَّلامُ ـ فِي الدُّنْيَا وَالْآخِرَةِ ، يَا أَبَا عَبْدِ اللهِ إِنِّي أَتَقَرَّبُ إِلى اللهِ وَإِلَى رَسُولِهِ وَإِلَى أَمِيرِ الْمُؤْمِنِينَ وَإِلَى فَاطِمَةَ وَإِلَى الْحَسَنِ وَإِلَيْكَ بِمُوَالاتِكَ وَبِالْبَرَاءَةِ [ مِمَّنْ قَاتَلَكَ وَنَصَبَ لَكَ الْحَرْبَ وَبِالْبَراءَةِ مِمَّنْ أَسَّسَ أَسَاسَ الظُّلْمِ وَالْجَوْرِ عَلَيْكُمْ وَأَبْرَأُ إِلَى اللهِ وَإِلَى رَسُولِهِ ] مِمَّنْ أَسَّسَ أَسَاسَ ذَلِكَ وَبَنَى عَلَيْهِ بُنْيَانَهُ وَجَرى فِي ظُلْمِهِ وَجَوْرِهِ عَلَيْكُمْ وَعَلَى أَشْيَاعِكُمْ ، بَرِئْتُ إِلَى اللهِ وَإِلَيْكُم مَِنْهُمْ ، وَأَتَقَرَّبُ إِلَى اللهِ ثُمَّ إِلَيْكُمْ بِمُوَالاتِكُمْ وَمُوَالاةِ وَلِيِّكُمْ وَبِالْبَرَاءَةِ مِنْ أَعْدَائِكُمْ وَالنَّاصِبِينَ لَكُمُ الْحَرْبَ وَبِالْبَرَاءَةِ مِنْ أَشْيَاعِهِمْ وَأَتْبَاعِهِمْ ، إِنِّي سِلْمٌ لِّمَنْ سَالَمَكُمْ وَحَرْبٌ لِّمَنْ حَارَبَكُمْ وَوَلِيٌّ لِّمَنْ وَالاكُمْ وَعَدُوٌّ لَِمَنْ عَادَاكُمْ ، فَأَسْأَلُ اللهَ الَّذِي أَكْرَمَنِي بِمَعْرِفَتِكُمْ وَمَعْرِفَةِ أَوْلِيَائِكُمْ وَرَزَقَنِيَ الْبَرَاءَةَ مِنْ أَعْدَائِكُمْ أَن يَّجْعَلَنِي مَعَكُمْ فِي الدُّنْيا وَالْآخِرَةِ ، وَأَن يُّثَبِّتَ لِي عِنْدَكُمْ قَدَمَ صِدْقٍ فِي الدُّنْيا وَالْآخِرَةِ ، وَأَسْأَلُهُ أَن يُّبَلِّغَنِيَ الْمَقَامَ الْمَحْمُودَ لَكُمْ عِنْدَ اللهِ ، وَأَن يَّرْزُقَني طَلَبَ ثَأْرِي مَعَ إِمَامِ هُدًى ظَاهِرٍ نَّاطِقٍ بِالْحَقِّ مِنْكُمْ ، وَأَسْألُ اللهَ بِحَقِّكُمْ وَبِالشَّأْنِ الَّذِي لَكُمْ عِنْدَهُ أَنْ يُعْطِيَنِي بِمُصَابِي بِكُمْ أَفْضَلَ مَا يُعْطِي مُصَاباً بِمُصِيبَتِهِ ، مُصِيبَةً مَّا أَعْظَمَهَا وَأَعْظَمَ رَزِيَّتَهَا فِي الْإِسْلامِ وَفِي جَمِيعِ السَّمَاوَاتِ وَالْأرْضِ ، اَللَّـهُمَّ اجْعَلْنِي فِي مَقَامِي هَذَا مِمَّنْ تَنَالُهُ مِنْكَ صَلَوَاتٌ وَّرَحْمَةٌ وَّمَغْفِرَةٌ ، اَللَّـهُمَّ اجْعَلْ مَحْيَايَ مَحْيَا مُحَمَّدٍ وَّآلِ مُحَمَّدٍ ، وَّمَمَاتِي مَمَاتَ مُحَمَّدٍ وََآلِ مُحَمَّدٍ ، اَللّّـهُمَّ إِنَّ هَذَا يَوْمٌ تَبَرَّكَتْ بِهِ بَنُو أُمَيَّةَ وَابْنُ آكِلَةِ الْأَكْبَادِ اللَّعِينُ بْنُ اللَّعِينِ عَلَى لِسَانِكَ وَلِسَانِ نَبِيِّكَ ـ صَلَّى اللهُ عَلَيْهِ وَآلِهِ ـ فِي كُلِّ مَوْطِنٍ وَّمَوْقِفٍ وَّقَفَ فِيهِ نَبِيُّكَ ـ صَلَّى اللهُ عَلَيْهِ وَآلِهِ ـ ، اَللَّـهُمَّ الْعَنْ أَبَا سُفْيَانَ وَمُعَاوِيَةَ وَيَزيدَ بْنَ مُعَاوِيَةَ عَلَيْهِم مِّنْكَ اللَّعْنَةُ أَبَدَ الْآبِدِينَ ، وَهَذَا يَوْمٌ فَرِحَتْ بِهِ آلُ زِيَادٍ وَآلُ مَرْوَانَ بِقَتْلِهِمُ الْحُسَيْنَ ـ صَلَواتُ اللهِ عَلَيْهِ ـ ، اَللَّـهُمَّ فَضَاعِفْ عَلَيْهِمُ اللَّعْنَ مِنْكَ وَالْعَذَابَ الْأَلِيمَ ، اَللَّـهُمَّ إِنِّي أَتَقَرَّبُ إِلَيْكَ فِي هَذَا الْيَوْمِ وَفِي مَوْقِفِي هَذَا وَأَيَّامِ حَيَاتِي بِالْبَرَاءَةِ مِنْهُمْ وَاللَّعْنَةِ عَلَيْهِمْ وَبِالْمُوَالاةِ لِنَبِيِّكَ وَآلِ نَبِيِّكَ ـ عَلَيْهِ وَعَلَيْهِمُ السَّلامُ ـ . ثمّ تقول مائة مرّة : اَللَّـهُمَّ الْعَنْ أَوَّلَ ظَالِمٍ ظَلَمَ حَقَّ مُحَمَّدٍ وَّآلِ مُحَمَّدٍ وَآخِرَ تَابِعٍ لَهُ عَلَى ذلِكَ ، اَللّـَهُمَّ الْعَنِ الْعِصَابَةَ الَّتي جَاهَدَتِ الْحُسَيْنَ ـ عَلَيْهِ السَّلَامُ ـ وَشَايَعَتْ وَبَايَعَتْ وَتَابَعَتْ عَلَى قَتْلِهِ ، اَللَّـهُمَّ الْعَنْهُمْ جَمِيعاً . ثمّ تقول مائة مرّة : اَلسَّلامُ عَلَيْكَ يَا أَبَا عَبْدِ اللهِ وَعَلَى الْأَرْوَاحِ الَّتِي حَلَّتْ بِفِنَائِكَ ، عَلَيْكَ مِنِّي سَلامُ اللهِ أَبَداً مَّا بَقِيتُ وَبَقِيَ اللَّيْلُ وَالنَّهَارُ ، وَلا جَعَلَهُ اللهُ آخِرَ الْعَهْدِ مِنِّي لِزِيَارَتِكُمْ ، اَلسَّلامُ عَلَى الْحُسَيْنِ ، وَعَلَى عَلِيِّ بْنِ الْحُسَيْنِ وَعَلَى أَوْلادِ الْحُسَيْنِ وَعَلَى أَصْحَابِ الْحُسَيْنِ . ثمّ تقول : اَللَّـهُمَّ خُصَّ أَنْتَ أَوَّلَ ظَالِمٍ بِاللَّعْنِ مِنِّي ، وَابْدَأْ بِهِ أَوَّلاً ، ثُمَّ الْعَنِ الثَّانيَ وَالثَّالِثَ وَالرَّابِعَ ، اَللّـَهُمَّ الْعَنْ يَزيدَ خَامِساً ، وَالْعَنْ عُبَيْدَ اللهِ بْنَ زِيَادٍ وَّابْنَ مَرْجانَةَ وَعُمَرَ بْنَ سَعْدٍ وَّشِمْراً وَآلَ أَبِي سُفْيَانَ وَآلَ زِيادٍ وََآلَ مَرْوَانَ إِلَى يَوْمِ الْقِيَامَةِ . ثمّ تسجد وتقُول : اَللَّـهُمَّ لَكَ الْحَمْدُ حَمْدَ الشَّاكِرِينَ لَكَ عَلَى مُصَابِهِمْ ، اَلْحَمْدُ للهِ عَلَى عَظِيمِ رَزِيَّتِي ، اَللَّـهُمَّ ارْزُقْنِي شَفَاعَةَ الْحُسَيْنِ يَوْمَ الْوُرُودِ ، وَثَبِّتْ لِي قَدَمَ صِدْقٍ عِنْدَكَ مَعَ الْحُسَيْنِ وَأَصْحَابِ الْحُسَيْنِ اَلَّذِينَ بَذَلُوا مُهَجَهُمْ دُونَ الْحُسَيْنِ عَلَيْهِ السَّلامُ .',
          open_ash:false,
          amd_dialog:false,
          is_search: false,
          pageCount: 0,
          page: 1,
          text: '',
          isMuted: true,
          video: null,
          dialog: false,
          dialog2: false,
          map_dialog: false,
          mapOptions: {
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            disableDefaultUI: false
          },
          coordinates: {},
          devAddress: '',
          add: '',
          phone: '',
          divInfo: [],
          live: [],
          atabat: [],
          liveDist: '',
          Amd:'',
          activeId: 1,
          Guids: [],
          PlacesCat: [],
          secCat: '',
          yt: false,
          yt_src: '',
          search: '',
          statistics: 0,
          baseDomain: window.location.hostname,
          ssc: [],
          playerLoading: true,
          axiosLoad: true,
          attrs: {
            class: 'sm-4',
            boilerplate: false,
            elevation: 2,
          },
          zeara_i: {
            name: '',
            email: '',
            ab: '',
            save: 'save'
          },
          zyaraData: [],
          zyaraText: '',
          loader: null,
          loading: false,
          player: null,
          videoOptions: {
            autoplay: 'any',
            poster: '',
            controls: true,
            fill: true,
            controlBar: {
              remainingTimeDisplay: false,
              currentTimeDisplay: false,
              timeDivider: false,
              durationDisplay: true
            },
            autoSetup: false,
            techOrder: ['youtube', 'html5'],
            sources: [{
              src: "https://stream.alkafeel.net/live/alkafeel/rAa5PGot1/manifest.m3u8",
              type: "application/x-mpegURL"
            }],
          },
          rules: {
            required: value => !!value || this.$t("required_field"),
            min: (v) => v.length >= 3 || this.$t("three_letters"),
            email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("alert_wrong_email"),
          },
          events: null,
          today: 1,
          modal_data: null,
          hash: null,
          langs: [],
          dir: 'rtl',
          lang: 'ar',
          logo: 'logo6.svg',
          lang_src: 'uploads',
          // ashab: null,
          khudam: [],

          currentCard: 1,
          cardData: [{
              title: "",
              description: "",
              image: ""
            },
            {
              title: "",
              description: "",
              image: ""
            },
            {
              title: "",
              description: "",
              image: ""
            }
          ],
          cards: [],
          settings: 
          {
            "dots": false,
            "infinite": true,
            "slidesToScroll": 3,
            "slidesToShow": 3,
            "centerPadding": "20px",
            "rtl": this.dir == 'rtl' ? true : false,
            "responsive": [
              {
                "breakpoint": 1024,
                "settings": {
                  "slidesToShow": 3,
                  "slidesToScroll": 3,
                }
              },
              {
                "breakpoint": 600,
                "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 2,
                }
              },
              {
                "breakpoint": 480,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1
                }
              }
            ]
          }
        };
      },
      watch: {
        loader() {
          const l = this.loader
          this[l] = !this[l]
          setTimeout(() => (this[l] = false), 3000)
          this.loader = null
        },
        axiosLoad(n, o) {

          if (!n && this.yt) {

            this.live_ini('yt');
            this.$refs.videoPlayer.load();
            setTimeout(() => this.loadPlayer(), 1000);
            setTimeout(() => this.playerLoading = false, 500);
          } else {

            this.live_ini('native');
            this.$refs.videoPlayer.load();
            setTimeout(() => this.loadPlayer(), 1000);
            setTimeout(() => this.playerLoading = false, 500);
          }
          this.live_atabat();
        }
      },
      components: {
        BreakingNews,VueSlickCarousel 
      },
      directives: {},
      computed: {
        currentTitle() {
          return this.cardData[this.currentCard % this.cardData.length].title;
        },
        currentDescription() {
          return this.cardData[this.currentCard % this.cardData.length].description;
        }
      },
      beforeCreate() {
        // document.title = this.$t("muharram");
        document.title = this.$t("visitor_guide");

        this.$axios.get("zyara/GetDetails")
          .then(d => {
            this.zyaraData = d.data.Data;
          });

        this.$axios.get("live/zyara")
          .then(d => {
            this.zyaraText = d.data[0].text;
          })

        this.$axios.get("get_events")
          .then(d => {
            this.events = d.data.Data[0].event;
            this.today = d.data.Data[0].date_d;
          });


      },
      created() {
        this.get_langs();
        this.getPlace(3);
        this.GetPlacesCat();
        this.GET_Guid();
        this.lang_fn();
        this.ashabfn(20);
        this.khudamfn(15);
        this.$axios.get("https://alkafeel.net/women_library/api/visitor_num_mh");
        this.$axios.get("https://alkafeel.net/main_bg/data/live_proxy.php?t=" + Date.now())
          .then(d => {
            if (d.status === 200 && d.data.live) {

              this.yt_src = d.data.videoId;
              this.yt = true;
              this.axiosLoad = false
            } else {
              this.axiosLoad = false
            }
          });

        if (this.$route.hash !== '') {
          this.hash = this.$route.hash.replace('#', '');
        }




      
            var dir;

            let params = (new URL(document.location)).searchParams;
            var lang = params.get("lang");
            if (lang == 'en' || lang == 'de' || lang == 'fr' || lang == 'sw' || lang == 'tr') {
                dir = 'ltr';
            } else {
                dir = 'rtl';
            }

            this.$store.dispatch("UpdateLang", {
                lang: lang,
                dir: dir
            });
         


      },
      mounted() {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
            var video = document.getElementById("video-background");
            var image = document.createElement("img");
            image.src = "/assets/img/moharam/main-bg-3.jpg";
            
            video.parentNode.replaceChild(image, video);
        }

        const theme = localStorage.getItem("dark_theme");
        if (theme) {
            if (theme === "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if ( window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
        } else {
            this.$vuetify.theme.dark = false;
            localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
        }
        
        this.video = this.$refs.videoss;
        this.showCard(this.currentCard);
        
        document.getElementById('next').addEventListener('click', () => {
          const middleCard = document.querySelector('.custom-card:nth-child(2)');
          middleCard.style.transition = 'transform 2s ease-in-out, opacity 1s ease-in-out';
          middleCard.style.transform = 'rotateY(10deg)';
          middleCard.style.opacity = 0;

          setTimeout(() => {
            this.showCard((this.currentCard + 1) % this.cardData.length);
            this.currentCard = (this.currentCard + 1) % this.cardData.length;

            setTimeout(() => {
              middleCard.style.transition = 'transform 1s ease-in-out, opacity 1s ease-in-out';
              middleCard.style.transform = 'rotate(9deg)';
              middleCard.style.opacity = 1;
            }, 100);
          }, 1000);
        });

        document.getElementById('prev').addEventListener('click', () => {
          const middleCard = document.querySelector('.custom-card:nth-child(2)');
          middleCard.style.transition = 'transform 2s ease-in-out, opacity 1s ease-in-out';
          middleCard.style.transform = 'rotateY(10deg)';
          middleCard.style.opacity = 0;

          setTimeout(() => {
            this.showCard((this.currentCard - 1 + this.cardData.length) % this.cardData.length);
            this.currentCard = (this.currentCard - 1 + this.cardData.length) % this.cardData.length;

            setTimeout(() => {
              middleCard.style.transition = 'transform 1s ease-in-out, opacity 1s ease-in-out';
              middleCard.style.transform = 'rotate(9deg)';
              middleCard.style.opacity = 1;
            }, 100);
          }, 1000);
        });
      },


      updated() {
        this.lang_dt(this.$route.query.lang);
      },
      beforeDestroy() {
        if (this.player) {
          this.player.dispose();
        }
      },
      methods: {
        route_rdr (code) {
          location.replace(location.protocol + '//' + location.host + location.pathname+'?lang='+code);
        },
        lang_dt (url) {
          if (url === undefined) {
              this.change_lang ('ar');
              return;
          }
          this.change_lang (url)
        },
        change_lang (code) {
          // console.log(code);
          this.languageOptions.forEach(element => {
              if (element.code === code) {

                this.lang = code;
                this.logo = element.logo;
                this.dir = element.dir == '1' ? 'rtl' : 'ltr';
                this.$store.dispatch("UpdateLang",{lang:this.lang,dir:this.dir});

                  // if (this.lang != 'ar') {
                  //   this.$store.commit('getI18nData', this.lang);
                  // } else {
                  //   location.replace(location.protocol + '//' + location.host + location.pathname);
                  // }

                  this.$vuetify.rtl = this.dir === 'rtl' ? true : false;
              }
          });
        },
        get_langs () {
          this.$axios.get("https://alkafeel.net/main_bg/data/core_langs_main.json")
          .then((res) => {
            this.languages = res.data
          });
        },
        bbcode (x) {
                return bbCodeParser.parse(this.stripHTML(x));
            },

            stripHTML (value) {
                const div = document.createElement('div')
                div.innerHTML = value
                const text = div.textContent || div.innerText || ''
                return text
                // return value.replace(/(<\/?(?:a|ol|ul|li|table|colgroup|col|tr|th|td|tbody|em|strong|s|span|img)[^>]*>)|<[^>]+>/ig, '$1');
            },
        open_ashs(){
       
          this.open_ash=true;
        },
        searchs() {
          this.is_search = true;
          this.next(1);

        },
        ashabfn(limit) {
          this.$axios.get("ashura/0/" + limit)
            .then((d) => {
              this.cardData = d.data;
              this.showNext();
            });
        },
        khudamfn(limit) {
          this.$axios.get("ashura/1/" + limit)
            .then((d) => {
              this.khudam = d.data;
            });
        },
        next(page) {
          if (this.is_search == true) {
            this.$axios.get("Guid/search/" + this.search + '?page=' + page, ).then((d) => {
              this.Guids = d.data.data.data;
              this.last_page = d.data.data.last_page;
              this.pageCount = d.data.data.last_page;

            });
          } else {
            this.$axios.get("Guid/getplacesbycat/" + this.secCat + '?page=' + page, ).then((d) => {
              this.Guids = d.data.data.data;
              this.last_page = d.data.data.last_page;
              this.pageCount = d.data.data.last_page;

            });
          }



        },

        getPlace(id) {
          this.secCat = id,
            this.next(this.page, id);

          //getplacesbycat



        },
        toggleSound() {
          this.isMuted = !this.isMuted;
          this.video.muted = this.isMuted;
          this.player.pause();
          // console.log(this.player.pause());
        },

        theFormat(number) {
          return number.toFixed(0);
        },

        scrollToSection(sectionId) {
          var section = document.getElementById(sectionId);
          section.scrollIntoView({
            behavior: 'smooth'
          });
        },
        show(y, a, p, l, lo) {
          this.coordinates = {
            lat: parseFloat(l),
            lng: parseFloat(lo)
          };;
          this.devAddress = y;

          this.add = a;
          this.phone = p;



          this.map_dialog = true;

        },
        format_coordinates(x) {
          var i = x.split(',');
          return {
            lat: parseFloat(i[0]),
            lng: parseFloat(i[1])
          };
        },


        live_ini(type) {

          this.$axios.get("live/all")
            .then((d) => {
              this.live = d.data;
              // console.log(type);
              if (type === 'yt') {
                this.videoOptions.sources[0].src = '//www.youtube.com/watch?v=' + this.yt_src;
                this.videoOptions.sources[0].type = 'video/youtube'
              } else {
                this.videoOptions.sources[0].src = d.data[0]['src'];
                this.videoOptions.sources[0].type = 'application/x-mpegURL'
              }

              this.videoOptions.poster = 'https://alkafeel.net/live/images/' + d.data[0]['pic'];
              this.liveDist = d.data[0]['title'];
              this.activeId = d.data[0]['id'];

            });
        },

        //https://alkafeel.net/alkafeel_back_test/api/v1/Guid


        GetPlacesCat() {
          this.$axios.get("Guid/placescat")
            .then((d) => {
              this.PlacesCats = d.data;
            });
        },
        GET_Guid() {
          this.$axios.get("Guid")
            .then((d) => {
              this.Guids = d.data.data.data;
            });
          if (this.hash) setTimeout(() => this.scrollToSection(this.hash), 2000);
        },


        live_atabat() {
          this.$axios.get("live/atabat")
            .then((d) => {
              this.atabat = d.data;
            });
          if (this.hash) setTimeout(() => this.scrollToSection(this.hash), 2000);
        },
        playSrc(src, pic, title, id, type = 'application/x-mpegURL', atabat = false) {
          if (this.yt && !atabat) {
            src = '//www.youtube.com/watch?v=' + this.yt_src;
            type = 'video/youtube'
          }
          this.player.poster('https://alkafeel.net/live/images/' + pic);
          this.player.src({
            type: type,
            src: src
          });
          this.liveDist = title;
          this.activeId = id;
          this.player.play();

          // scroll to pos
          // window.scrollTo({ top: 140, behavior: 'smooth'});
          // let rect = this.$el.querySelector('.dist_stat').getBoundingClientRect()
          // window.scrollTo(rect.left, rect.top)
        },

        loadPlayer() {
          this.player = videojs(this.$refs.videoPlayer, this.videoOptions);
        },
        zyara_send() {
          if (this.$refs.form.validate()) {
            var formdata = new FormData();
            formdata.append("name", this.zeara_i.name);
            formdata.append("ab", this.zeara_i.ab);
            formdata.append("save", "save");
            formdata.append("email", this.zeara_i.email);
            this.loader = 'loading';
            this.$axios({
              method: 'post',
              url: 'https://alkafeel.net/zyara/Avdasdw/1352897989/post',
              data: formdata,
            }).then(res => {
              res
              this.zeara_i = {};
              Swal.fire({


                position: 'center',
                icon: 'success',
                title: this.$t("zeara_result"),
                showConfirmButton: false,
                timer: 2000
              });
            });
          }
        },
        data_tbl(id) {

          this.$axios.get("GetMawakeb/day/" + id)
            .then(d => {
              this.divInfo = d.data.Data;
              this.dialog = true;
            })

        },

        data_tbl2() {

          this.dialog2 = true;

        },

        lang_fn() {
          this.$axios.get("https://alkafeel.net/main_bg/data/core_langs_main.json")
            .then((data) => {
              this.langs = data.data;
            });
        },

        lang_dt(url) {
          if (url === undefined) {
            this.lang_ck('ar');
            return;
          }
          this.lang_ck(url)
        },
        lang_ck(code) {
          this.langs.forEach((element, index) => {
            if (element.code === code) {
              this.lang = code;
              this.$i18n.locale = code;
              this.dir = element.dir == '1' ? 'rtl' : 'ltr';
              this.logo = element.logo;
              if (code !== 'ar') this.lang_src = 'src/svg';
              this.$vuetify.rtl = this.dir === 'rtl' ? true : false;
              this.$axios.defaults.headers.get['lang'] = this.$i18n.locale;
            }
          });
        },

        showCard(cardNumber) {
          this.cards = [
            this.cardData[(cardNumber - 1 + this.cardData.length) % this.cardData.length],
            this.cardData[cardNumber % this.cardData.length],
            this.cardData[(cardNumber + 1) % this.cardData.length]
          ];
        },
        showNext() {
          this.currentCard = (this.currentCard + 1) % this.cardData.length;
          this.showCard(this.currentCard);
        },
        showPrev() {
          this.currentCard = (this.currentCard - 1 + this.cardData.length) % this.cardData.length;
          this.showCard(this.currentCard);
        },

        openModal(modalId,amd) {
          this.amd_dialog=true;
          this.Amd=amd;
          document.getElementById(modalId).style.display = "block";
        },
        closeModal(modalId) {
          document.getElementById(modalId).style.display = "none";
        },
        outsideClick(event) {
          if (event.target.classList.contains('modal')) {
            event.target.style.display = "none";
          }
        }


      }
    }
  </script>
  <style scoped>
    .custom-arrow2 {
      background-color: #a119199e;
      color: white;
      border: none;
      padding: 10px;
      cursor: pointer;
      border-radius: 4px;
      width: 35px;
      height: 45px;
    }
    .slick-prev:before, .slick-next:before {
      font-family: 'Times New Roman', Times, serif;
    }
    .guid-search input {
      color: #000 !important
    }

    .serv {
      fill: #FFF;
      width: 15px;
      height: 15px;
      margin: 0 5px 5px;
    }

    .height {
      width: 100%;
      height: 100%;
    }

    .ico {
      stroke: #FFF;
      transition: .3s ease all;
    }

    .ico2 {
      fill: #FFF;
      transition: .3s ease all;
    }

    .play_ltr {
      left: calc(10% - 1px);
      right: auto !important;
      top: 10% !important;
      transform: rotate(180deg);
    }

    .play1 {
      position: absolute;
      top: calc(50% - 7px);
      right: calc(10% - 1px);
      width: 28px;
      fill: #B1BD52;
      transition: .3s ease all;
    }

    .play_side {
      position: absolute;
      top: calc(50% - 32px);
      right: calc(80% - 32px);
      width: 64px
    }

    .cam_btn {
      background: #303030;
      cursor: pointer;
      box-shadow: 0px 4px 22px rgba(0, 0, 0, 0.07);
      transition: .3s ease all;
      border-radius: 4px;
      text-align: center;
      align-items: center;
    }

    .cam_btn:hover {
      background: #910000 !important;
    }

    .cam_btn:hover .play1 {
      fill: #FFF !important;
    }

    .cam_active {
      background: #910000 !important;
      color: #fff;
    }

    .cam_active .play1 {
      fill: #FFF !important;
    }

    .pointer {
      cursor: pointer;
    }

    .pointer img {
      /* height: 28px; */
      margin: 8px;
    }

    .main-stats {
      display: flex !important;
      flex-direction: row;
      justify-content: space-around;
    }

    #videoObject {
      min-height: 700px;
      border-radius: 5px;
      border: solid 2px #D4D4D4;
    }

    .live {
      width: 100%;
      padding-top: 30px;
      max-width: 1260px;
    }

    .relative {
      position: relative;
    }

    .player_wrap {
      width: 100% !important;
      height: 500px !important;
      margin-bottom: 25px;
    }

    @media (max-width: 600px) {
      .player_wrap {
        height: 300px !important;
      }

      .zyara_cat {
        font-size: 18px !important;
      }
    }

    @media (max-width: 420px) {
      .player_wrap {
        height: 200px !important;
      }
    }

    .play {
      position: absolute;
      top: calc(50% - 32px);
      right: calc(50% - 32px);
      width: 64px
    }

    .comments {
      padding: 0 10px;
      margin-top: 7px;
    }

    .zyara_cat {
      font-size: 24px;
      font-family: 'cairo_bold';
      color: #fff;
    }

    .vjs-control-bar {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%) !important;
    }

    .vjs-theme-dt {
      --color-primary: #B1BD52 !important;
    }

    .events {
      color: #fff;
      position: relative;
      font-weight: bold;
      border: .5px solid #ffffff44;
      border-radius: 4px;
    }

    .gradiant_img {
      display: none;
      background: rgba(0, 0, 0, .5);
      text-align: center;
    }

    .sec:hover .gradiant_img {
      display: block;
      cursor: pointer;
    }


    .title {
      text-align: center;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;
      padding: 0 0 24px 0;
      text-decoration: none;
      color: #fff;
      position: relative;
    }

    .bg-dark {
      background-color: #303030;
      width: 100%;
      height: 100vh;
    }

    .d-flex {
      display: flex;
    }

    .logo,
    .list {
      justify-content: center;
      padding: 16px;
      border-bottom: 1px solid #d9d9d96e;
      flex-direction: column;

    }

    .list img {
      height: 42px;
    }

    .text-white {
      color: #fff
    }

    .m-bg {
      background-image: url('/assets/img/moharam//m-bg.png');
      background-attachment: fixed;
      background-size: cover;
      position: fixed;
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }

    .p-f {
      position: fixed;
    }

    .pointer {
      cursor: pointer;
    }

    .b-bottom {
      border-bottom: 2px solid rgb(185, 0, 0);
    }

    @media (min-width: 320px) and (max-width: 766px) {

      .main-stats {
        display: flex !important;
        flex-direction: column;
      }


      .b-bottom {
        width: 50%;
        margin: 0 auto;
      }
    }

    #video-background {
      position: fixed;
      right: 0;
      bottom: 0;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      z-index: -1;
    }

    .content {
      position: relative;
      z-index: 1;
    }
.v-btn__content{
width: 100% !important;
}
    .au-container {
      height: 48px;
      width: 48px;
      margin: 12px 0;
      position: absolute;
      /* left: 0; */
    }

    .au-container button {
      padding: 12px;
    }

    .w-100 {
      width: 100% !important;
    }

    .l-img img {
      height: 48px;
    }

    .l-color {
      color: #ccc;
      font-size: 11px;
    }

    .l-img {
      display: flex;
      align-items: center;
      margin: 0 4px 4px 8px;
    }

    .location-div {
      margin: 12px;
      padding: 12px;
      background: #000;
      border-radius: 6px;
      align-items: center;
      min-width: 200px;
      flex-direction: column;
    }

    @media (min-width: 320px) and (max-width: 767px) {

      .l-main {
        flex-direction: column !important;
      }

      .location-div {
        flex-direction: row;
        justify-content: space-between;
      }

      .sub-location {
        display: flex;
      }
    }

    .custom-section {
      /* background: url('shuhada-bg.png') no-repeat center center/cover; */
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      direction: rtl;
      position: relative;
    }

    .custom-content {
      max-width: 40%;
      color: white;
    }

    .custom-title {
      font-size: 1.9rem;
      margin-bottom: 20px;
      color: rgb(221, 38, 38);
      font-weight: 700;
      background-color: #0000003d;
    }

    .custom-description {
      font-size: 1.2rem;
    }

    .custom-card-container {
      position: relative;

      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .custom-card {
      position: absolute;
      width: 450px;
      height: 450px;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 10px;
      transition: transform 1s ease-in-out, opacity 1s ease-in-out;
      /* تعديل التأثير */
      overflow: hidden;
    }

    .custom-card img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .custom-arrows {
      position: absolute;
      bottom: 0;
      width: 98%;
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      direction: rtl;

    }

    .custom-arrow {
      background-color: #a119199e;
      color: white;
      border: none;
      padding: 10px;
      cursor: pointer;
      border-radius: 4px;
    }

    @media (max-width: 768px) {
      .custom-section {
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .custom-content {
        max-width: 90%;
        text-align: center;
        margin-bottom: 20px;
      }

      .custom-card-container {
        width: 90%;
        height: auto;
      }

      .custom-card {
        width: 100%;
        height: auto !;
      }

      .custom-arrows {
        top: auto;
        bottom: 10px;
        width: auto;
        display: flex;
        justify-content: space-evenly;
        width: 100%;
      }
    }

    .khdham {
      background: #171717;
      min-height: 100vh;
    }

    img {
      max-width: 100%;
      display: block;
    }

    ul {
      list-style-type: none;
    }

    ul i {
      color: #fff;
      font-size: clamp(0.9rem, 0.825rem + 0.3vw, 1.2rem);
    }

    ul i:hover {
      color: #D72020;
    }

    .khdham {
      font-weight: 300;
      font-style: normal;
      padding-block: min(20vh, 6rem);
      text-align: center;
      width: calc(min(90rem, 90%));
      margin-inline: auto;
    }

    .khdham span,
    .khdham p,
    .khdham h2,
    .khdham h3 {
      letter-spacing: 0.035rem;
    }

    .khdham p {
      line-height: 1.6;
      color: #000;
      max-width: 50rem;
      margin: 0 auto;
      font-size: clamp(0.9rem, 0.825rem + 0.3vw, 1.2rem);
    }

    .khdham .bg-watermark {
      color: #1f1f1f;
      font-size: clamp(6rem, 1.3333rem + 14.9333vw, 20rem);
      font-weight: 800;
      position: absolute;
      z-index: -1;
      right: 50%;
      transform: translatex(50%) translatey(-15%);
      user-select: none;
      letter-spacing: 0.5rem;
    }

    .khdham span {
      text-transform: uppercase;
      color: #fff;
    }

    .khdham h2 {
      font-size: clamp(3.5rem, 3rem + 1.6vw, 5rem);
      margin-top: -0.625rem;
      color: #b01a1a;
    }

    .khdham .cards {
      margin-top: 2rem;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(min(12rem, 100%), 1fr));
      gap: 2rem;
    }

    @media screen and (min-width: 51rem) {
      .khdham .cards {
        gap: 0;
        padding-bottom: 2.5rem;
      }
    }

    .khdham .cards .card {
      position: relative;
      cursor: pointer;
    }

    .khdham .cards .card h3,
    .khdham .cards .card p {
      text-transform: capitalize;
    }

    .khdham .cards .card h3 {
      font-size: clamp(1rem, 0.9167rem + 0.2667vw, 1.25rem);
      font-weight: 400;
      color: #f6f6f6;
    }

    .khdham .cards .card p {
      font-size: clamp(0.85rem, 0.75rem + 0.32vw, 1.15rem);
      font-weight: 300;
      max-width: 100%;
    }

    .khdham .cards .card::before {
      position: absolute;
      content: "";
      width: 5rem;
      height: 6.25rem;
      z-index: 0;
      transition: 0.3s ease-in-out;
      background: linear-gradient(to right, #cb1e1e, #801313);
      top: -0.375rem;
      right: -0.375rem;
    }

    .khdham .cards .card::after {
      position: absolute;
      inset: 0;
      content: "";
      width: 100%;
      height: 100%;
      background: #232526;
      background: -webkit-linear-gradient(to bottom, rgba(65, 67, 69, 0.2), rgba(8, 8, 8, 0.9));
      background: linear-gradient(to bottom, rgba(65, 67, 69, 0.2), rgba(8, 8, 8, 0.9));
    }

    .khdham .cards .card img {
      filter: grayscale(100%);
      transition: 0.5s ease;
    }

    .khdham .cards .card-content {
      position: absolute;
      bottom: 0;
      z-index: 99;
      right: 0;
      color: #fff;
      width: 100%;
      padding: 1.875rem 1.25rem;
      text-align: center;
    }

    .khdham .cards .card-content ul {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.625rem;
      margin-top: 1.25rem;
    }

    .khdham .cards .card:hover img {
      filter: grayscale(0%);
    }

    .khdham .cards .card:hover::before {
      transform: scale(1.03);
    }

    .khdham .cards .card:nth-child(1)::before {
      top: -0.375rem;
      right: -0.375rem;
    }

    @media screen and (min-width: 31.25rem) {
      .khdham .cards .card:nth-child(2) {
        transform: translatey(15%);
      }
    }

    .khdham .cards .card:nth-child(2)::before {
      bottom: -0.375rem;
      right: -0.375rem;
      top: auto;
    }

    .khdham .cards .card:nth-child(3)::before {
      top: -0.375rem;
      right: -0.375rem;
    }

    .unique-button {
      border: none;
      color: white;
      padding: 15px 15px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      font-size: 16px;
      margin: 4px 2px;
      cursor: pointer;
      border-radius: 4px;
    }

    .button-ashura {
      background-color: #961c1c;
    }

    .button-hussein {
      background-color: #303030;
    }

    .modal {
      display: none;
      position: fixed;
      z-index: 1;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgb(0, 0, 0);
      background-color: rgba(0, 0, 0, 0.4);
      padding-top: 60px;
    }

    .modal-content {
      background-color: #040404bf;
      margin: 5% auto;
      padding: 20px;
      border-radius: 4px;
      width: 80%;
      /* white-space: pre-wrap; */
    }

    .modal-content h3 {
      color: #fff;
      margin: 12px;
    }

    .close {
      color: #b11b1b;
      float: left;
      font-size: 28px;
      font-weight: bold;
    }

    .close:hover,
    .close:focus {
      color: black;
      text-decoration: none;
      cursor: pointer;
    }

    @media (min-width: 1025px) and (max-width: 8280px) {

      .uni-2 {
        transform: translatey(12%);
      }

    }

    .logo img {
      height: 62px;
    }

    .bg-dark-c {
      background-color: #3939392b;
    }

    .cu-p {
      text-align: center !important;
      color: #f3f3f3 !important;
      font-size: 16px !important;
      margin-top: 8px !important;
    }

    .card-content p {
      color: #999999;
    }

    .more-cu {
      width: 450px;
      height: 550px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media (min-width: 320px) and (max-width: 1023px) {

      .more-cu {
        width: 100%;
        height: 400px;
        margin: 16px 10px;
      }

      .custom-card {
        height: 315px;
      }

    }

    .text-white {
      color: #fff !important;

    }

    .bg-red {
      background: #910000  !important;

    }

    .bg-red  p{
      background: #910000  !important;
      padding: 20px 8px !important;
      font-size: 14px !important;


    }

    .ico-cu {
      border-radius: 50%;
      padding: 16px;
      /* border: 2px solid #b90000; */
      width: 64px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      height: 64px;
    }

    .main-table {
      background: transparent !important;
      height: 650px !important;
      overflow-y: scroll;
    }
    .transparent {
      background: transparent !important;
    }

    .border {
      border: 1px solid #ffffff41 !important

    }

    .modal_image {
      border-radius: 50%;
      width: 72px;
      height: 72px;
      object-fit: contain;
      margin: 0 auto;
      border: 1px solid #ccc;
    }

    .button-text1 {
      padding: 20px;
      width: 400px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      line-height: 1.5;
      background-color: rgb(145, 0, 0) !important;
    }

    @media (min-width: 320px) and (max-width: 1023px) {
      .custom-section {
        flex-direction: column-reverse;
      }

      .button-text1 {
        width: 320px !important;
        font-size: 13px !important;
      }
  
}

.v-list-item__content {
    font-weight: bold;
    border-bottom: 1px solid #888888;
    color: #4e4e4e;
}

.lang-bu {
    BACKGROUND: #ce0404;
    COLOR: #FFF !important;
    width: 85%;
}


@media (min-width: 1600px) {
    .custom-size {
      max-width: 100%;
    }
}

.lang-text {
  color: #797979 ;
}

.text-khdham {
  white-space: pre-wrap;
}

#app {
  overflow-x: hidden !important;
}

.m-0 {
  margin: 0 !important;
}
  </style>